import React from 'react';

const Header = ({
  title,
  subtitle,
  showButton = false,
  buttonText = '',
  onButtonClick,
  showInput = false,
  inputValue = '',
  onInputChange,
  disabled = false,
}) => {
  return (
    <header className="flex justify-between items-center bg-white rounded-2xl p-8 shadow-xl flex-wrap gap-4">
      <div className="space-y-2">
        <h1 className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-blue-600 to-blue-800 bg-clip-text text-transparent">
          {title}
        </h1>
        {subtitle && <p className="text-gray-600 text-lg">{subtitle}</p>}
      </div>

      <div className="flex items-center gap-3 w-full md:w-auto">
        {showInput && (
          <input
            type="email"
            placeholder="Ingresa tu correo"
            value={inputValue}
            onChange={onInputChange}
            className="border border-gray-300 rounded px-4 py-2 w-full md:w-auto"
          />
        )}

        {showButton && (
          <button
            onClick={onButtonClick}
            disabled={disabled}
            className={`flex items-center justify-center gap-2 px-5 py-2 rounded-lg shadow transition 
              ${disabled 
                ? 'bg-gray-400 text-white cursor-not-allowed' 
                : 'bg-blue-600 hover:bg-blue-700 text-white'
              }`}
          >
            {buttonText}
          </button>
        )}
      </div>
    </header>
  );
};

export default Header;
